import {
    formatCascade,
    type PayoutCascade,
    type PayoutCascadeQueueItemInput,
    PayoutCascadeQueueItemType,
} from '~/entities/payout';
import { type OrderedEntry } from '~/shared/ui/OrderedEntryList';
import { type QueueEntryValue } from './types';

const createEntryKey = () => `${Date.now()}-${Math.random().toString(36).slice(2)}`;

export const cascadeToQueueEntries = (cascade: PayoutCascade): OrderedEntry<QueueEntryValue>[] => {
    return (cascade.queueItems ?? []).map((item) => ({
        key: createEntryKey(),
        value: {
            type: item.type ?? PayoutCascadeQueueItemType.QUEUE_ITEM_TYPE_GROUP,
            id: item.group?.id?.value ?? item.template?.id?.value ?? '',
            name: formatCascade.queueItemName(item),
        },
    }));
};

export const createQueueEntry = (type: PayoutCascadeQueueItemType, id: string, name: string): OrderedEntry<QueueEntryValue> => ({
    key: createEntryKey(),
    value: { type, id, name },
});

export const queueEntriesToPayload = (entries: OrderedEntry<QueueEntryValue>[]): PayoutCascadeQueueItemInput[] => {
    return entries.map((entry) =>
        entry.value.type === PayoutCascadeQueueItemType.QUEUE_ITEM_TYPE_TEMPLATE
            ? { templateId: { value: entry.value.id } }
            : { groupId: { value: entry.value.id } },
    );
};
